import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import StatusChip from "./StatusChip";

/**
 * Compact, subordinate KATLAS status indicator for the footer.
 * Clicking it opens Diagnostics. Never shows token, header, cert text or envelope.
 */
export default function KatlasStatusBadge() {
    const [s, setS] = useState(null);
    useEffect(() => {
        api.katlasStatus()
            .then(setS)
            .catch(() => setS({ status: "unreachable", label: "KATLAS status unavailable" }));
    }, []);
    return (
        <Link
            to="/diagnostics"
            className="inline-flex items-center gap-2 group"
            data-testid="footer-katlas-status-link"
        >
            <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-ink-muted group-hover:text-ink">
                KATLAS status:
            </span>
            <StatusChip
                status={s?.status}
                label={s?.label ? s.label.replace(/\u2014/g, "·") : undefined}
                testId="footer-katlas-status-chip"
            />
        </Link>
    );
}
